module.exports = __webpack_public_path__ + "img/down.9cd6687a.gif";